
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Map/index.md?watch=parent';
    export const toc = [{"id":"代码示例","depth":3,"title":"代码示例"}];
export const frontmatter = {"title":"Map","toc":"content","filename":"src/Map/index.md","atomId":"Map","lastUpdated":1752854267000,"order":1,"group":{"order":2,"title":"地图"},"debug":true};